module.exports = __webpack_public_path__ + "img/wallet-2-fill.4b31568f.svg";